export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";